import React from 'react'
import Grid from '@material-ui/core/Grid';
import TextField from 'components/TextField'
import FormSection from 'components/FormSection'
import { required, isEmail } from 'helpers/Validators'
import WysiwygEditor from 'components/WysiwygEditor'
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';

const Summary = () => (
  <FormSection
    title={(
      <Typography variant="h6" component="h2">
        O mnie 
      </Typography> 
    )}
    subtitle={(
      <Typography component="p">
        Wpisz 2-3 zdania o sobie i swoim doświadczeniu.
      </Typography>
    )}
  >
    <WysiwygEditor
      name="summary"
      type="text"
      label="Summary"
    />
  </FormSection>
)

export default Summary